import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { newSubscriptionAction } from '../../../store/actions/subscriptionActions';
import { useDispatch } from 'react-redux';

const PaymentMethodModal = ({openModal, setOpen, productId, productPpData}) => {
    const [selectedPayment, setSelectedPayment] = useState('prism-pay');
    const [isLoading, setIsLoading] = useState(false);
    const [prData, setPrData] = useState('');
    const dispatch = useDispatch();
    
    const closeModal = () => {
        setOpen(false);
        setSelectedPayment(''); 
    };
    useEffect(() => {
        setPrData(productPpData);
        // console.log(productPpData)
    }, [productId, productPpData])
    
    const handlePaymentSelect = (paymentType) => {
        setSelectedPayment(paymentType);
    };
    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const postData = {
                "productID": productId,
                "billingID": selectedPayment
            };
            
            const res = await dispatch(newSubscriptionAction(postData));
            
            // Handle success
            if (res && res.redirectUrl) {
                window.location.href = res.redirectUrl;
            }
            
            closeModal();
            
        } catch (error) {
            console.error('Subscription error:', error);
            // Handle error (show error message to user)
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
            <div className="modal app-theme-popup">
                <div className="modal-header">
                    <h3>Product details</h3>
                </div>
                <div className="modal-content">
                    <div className="popup-pInfo">
                        <h3>{prData?.title}</h3>
                        <span>${prData?.price}/{prData?.renewalIntervalUnit}</span>
                    </div>
                    <div className="payment-button">
                        <button className="btn button-cancel" onClick={closeModal}>
                            Cancel
                        </button>
                        <button 
                            onClick={handleSubmit}
                            className="btn button-submit" 
                        >
                            {isLoading ? 'Processing...' : `Pay $${prData?.price}`}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M1.99974 13.0001L1.9996 11.0002L18.1715 11.0002L14.2218 7.05044L15.636 5.63623L22 12.0002L15.636 18.3642L14.2218 16.9499L18.1716 13.0002L1.99974 13.0001Z"></path></svg>
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default PaymentMethodModal;